import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { ODataService } from '@mynexus/mynexus-ui-lib';
import { AuthenticationService } from './service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ShellService } from '@mynexus/mfe-core';
import { AuthorizationStateService } from '@app/feature/authorization-details/authorization-state.service';
import { DialogService } from 'primeng/dynamicdialog';
import { ProductStateService } from '@app/feature/authorization-details/product-widget/services';

@NgModule({
  exports: [CommonModule],
  imports: [CommonModule],
  providers: [
    AuthenticationService,
    AuthorizationStateService,
    ShellService,
    ODataService,
    MessageService,
    ConfirmationService,
    DialogService,
    ProductStateService,
    provideHttpClient(withInterceptorsFromDi())
  ]
})
export class CoreModule {
}
